import {
  createContext,
  type PropsWithChildren,
  useEffect,
  useState
} from 'react';
import { toast } from 'react-hot-toast';

const CommonWidgetContext = createContext({
  confettiRunning: false,
  throwConfetti: () => {}
});

export const CommonWidgetContextProvider = ({
  children
}: PropsWithChildren) => {
  const [confettiRunning, setConfettiRunning] = useState(false);
  // Read in the effects below from window.location, not useSearchParams: this
  // provider sits in the web app's prerendered shell, and a useSearchParams
  // read there makes the root layout's Suspense boundary a dynamic hole for
  // every page (Cache Components). The effects only run in the browser.
  const queryParam = (name: string) =>
    new URLSearchParams(window.location.search).get(name);

  useEffect(() => {
    if (confettiRunning) {
      const timer = setTimeout(() => {
        setConfettiRunning(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  });

  useEffect(() => {
    if (queryParam('welcome') === 'true') {
      setConfettiRunning(true);
      // router.replace(router.pathname, { shallow: true });
    }
  });

  useEffect(() => {
    if (queryParam('donation') === 'success') {
      setConfettiRunning(true);
      toast.success('Thank you for your donation!');
      // router.replace(router.pathname, undefined, { shallow: true });
    }
  });

  const contextValue = {
    confettiRunning,
    throwConfetti: () => setConfettiRunning(true)
  };

  return (
    <CommonWidgetContext.Provider value={contextValue}>
      {children}
    </CommonWidgetContext.Provider>
  );
};

export default CommonWidgetContext;
